import {
  Content,
  Layout,
  Stack,
} from 'apps/dashboard/shared/scripts/components';
import { PRO_MODE_ENABLED } from 'apps/shared/scripts/feature-gating/constants';
import useFeatureGate from 'apps/shared/scripts/feature-gating/hooks';

import InvoicesContainer from '../InvoicesContainer';

import messages from './messages.json';

const BillingContainer = () => {
  const isProModeEnabled = useFeatureGate(PRO_MODE_ENABLED);

  return (
    <Layout>
      <Content title={messages.billingTitle}>
        <Stack>{isProModeEnabled && <InvoicesContainer />}</Stack>
      </Content>
    </Layout>
  );
};

BillingContainer.displayName = 'BillingContainer';

export default BillingContainer;
